import script from "./HeroStatsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroStatsTab.vue?vue&type=script&setup=true&lang=js"

import "./HeroStatsTab.vue?vue&type=style&index=0&id=34f424de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f424de"]])

export default __exports__